import { z } from "zod"

export const email = z
  .string()
  .email({
    message: "Geen geldig e-mail adres",
  })
  .transform((str) => str.toLowerCase().trim())

export const tel = z.string().transform((str) => str.trim())

export const name = z.string().transform((str) => str.trim())

export const message = z.string().transform((str) => str.trim())

export const Contact = z.object({
  email,
  name,
  tel,
  message,
})
